import { TacticApiClient } from '@gettactic/api';

/**
 * Creates a wrapper around a function that automatically provides the API client
 * as the last parameter. Useful for adapting hooks that require an API parameter.
 * 
 * @param fn The function to wrap (must accept API as the last parameter)
 * @param apiParam The API client instance to inject
 * @returns A new function that doesn't require the API parameter
 */
export function createApiWrapper<P extends unknown[], R>(
  fn: (...args: [...P, TacticApiClient?]) => R,
  apiParam: TacticApiClient
): (...args: P) => R {
  return (...args: P) => fn(...args, apiParam);
} 